import "./RudrakshaSection.css";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const RUDRAKSHA_CATEGORY_SLUG = "rudrakshas";
const banners = [
  "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793359854/1000457592_scqahy.png",
  "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793359854/1000457600_tjokjv.png",
  "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793359875/1000457602_mkvukl.png",
 
];
export default function RudrakshaSection() {
  const [rudrakshaCategory, setRudrakshaCategory] =
    useState(null);
  const [subcategories, setSubcategories] =
    useState([]);
  const [activeSubcategory, setActiveSubcategory] =
    useState(null);
  const [products, setProducts] = useState([]);
  const [loadingCategories, setLoadingCategories] =
    useState(true);
  const [loadingProducts, setLoadingProducts] =
    useState(false);

  // ==========================================
  // NORMALIZE SLUG
  // ==========================================

  const normalizeSlug = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");

  // ==========================================
  // IMAGE URL
  // ==========================================

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return "";

    if (
      imageUrl.startsWith("http://") ||
      imageUrl.startsWith("https://")
    ) {
      return imageUrl;
    }

    return `${API_BASE_URL}${imageUrl}`;
  };

  // ==========================================
  // FORMAT PRODUCT FOR PRODUCT CARD
  // ==========================================

  const formatProduct = (product) => {
    if (!product) return null;

    const primaryImage =
      product?.images?.find(
        (image) =>
          image?.isPrimary === true
      ) ||
      product?.images?.[0];

    return {
      ...product,

      // ID
      id: product?.id,

      // Product name
      title:
        product?.name ||
        product?.title ||
        "",

      name:
        product?.name ||
        product?.title ||
        "",

      // Main image
      image: getImageUrl(
        primaryImage?.imageUrl ||
          product?.imageUrl ||
          product?.image
      ),

      // Second image
      image2: getImageUrl(
        primaryImage?.thumbUrl ||
          product?.thumbUrl ||
          product?.image2
      ),

      // Price
      price: Number(
        product?.price || 0
      ),

      // Category
      category:
        product?.category?.name ||
        product?.categoryName ||
        "Rudraksha",

      // Subcategory
      subcategory:
        product?.subcategory?.name ||
        product?.subcategoryName ||
        "",

      // Rudraksha fields
      mukhi:
        product?.mukhiCount !== undefined
          ? product.mukhiCount
          : product?.mukhi || "",

      origin:
        product?.origin || "",

      beadSize:
        product?.beadSizeMm ||
        product?.beadSize ||
        "",

      certification:
        product?.isCertified !== undefined
          ? product.isCertified
            ? "Certified"
            : "Not Certified"
          : product?.certification || "",
    };
  };

  // ==========================================
  // FETCH RUDRAKSHA CATEGORY
  // ==========================================

  useEffect(() => {
    const fetchRudrakshaCategory =
      async () => {
        try {
          setLoadingCategories(true);

          const result = await getCategories();

          console.log(
            "ALL CATEGORIES:",
            result
          );

          if (!result?.success) {
            setRudrakshaCategory(null);
            setSubcategories([]);
            return;
          }

          const categories =
            Array.isArray(result?.data)
              ? result.data
              : [];

          // ======================================
          // FIND RUDRAKSHA CATEGORY
          // ======================================

          const rudraksha =
            categories.find(
              (category) =>
                normalizeSlug(
                  category?.slug
                ) ===
                normalizeSlug(
                  RUDRAKSHA_CATEGORY_SLUG
                ) ||
                normalizeSlug(
                  category?.name
                ) ===
                normalizeSlug(
                  RUDRAKSHA_CATEGORY_SLUG
                )
            );

          console.log(
            "RUDRAKSHA CATEGORY:",
            rudraksha
          );

          if (!rudraksha) {
            console.error(
              "Rudraksha category not found"
            );

            setRudrakshaCategory(null);
            setSubcategories([]);
            return;
          }

          setRudrakshaCategory(
            rudraksha
          );

          // ======================================
          // SUBCATEGORIES FROM CATEGORY API
          // ======================================

          if (
            Array.isArray(
              rudraksha?.subcategories
            )
          ) {
            setSubcategories(
              rudraksha.subcategories
            );

            return;
          }

          // ======================================
          // FALLBACK SUBCATEGORY API
          // ======================================

          if (rudraksha?.id) {
            const subResponse =
              await fetch(
                `${API_BASE_URL}/categories/${rudraksha.id}/subcategories`
              );

            if (!subResponse.ok) {
              setSubcategories([]);
              return;
            }

            const subResult =
              await subResponse.json();

            console.log(
              "RUDRAKSHA SUBCATEGORIES:",
              subResult
            );

            if (
              subResult?.success &&
              Array.isArray(
                subResult?.data
              )
            ) {
              setSubcategories(
                subResult.data
              );
            } else {
              setSubcategories([]);
            }
          }
        } catch (error) {
          console.error(
            "Rudraksha Category API Error:",
            error
          );

          setRudrakshaCategory(null);
          setSubcategories([]);
        } finally {
          setLoadingCategories(false);
        }
      };

    fetchRudrakshaCategory();
  }, []);

  // ==========================================
  // GET PRODUCTS RESPONSE
  // ==========================================

  const extractProducts = (result) => {
    console.log(
      "RAW PRODUCTS RESPONSE:",
      result
    );

    // Case 1:
    // { success: true, data: { products: [] } }

    if (
      Array.isArray(
        result?.data?.products
      )
    ) {
      return result.data.products;
    }

    // Case 2:
    // { data: { products: [] } }

    if (
      Array.isArray(
        result?.data?.data?.products
      )
    ) {
      return result.data.data.products;
    }

    // Case 3:
    // { products: [] }

    if (
      Array.isArray(
        result?.products
      )
    ) {
      return result.products;
    }

    // Case 4:
    // API directly returns array

    if (Array.isArray(result)) {
      return result;
    }

    return [];
  };

  // ==========================================
  // FETCH ALL RUDRAKSHA PRODUCTS
  // ==========================================

  const fetchAllProducts = async (
    categoryId
  ) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result =
        await getProducts({
          categoryId: categoryId,
          page: 1,
          limit: 12,
        });

      console.log(
        "ALL RUDRAKSHA PRODUCTS RESPONSE:",
        result
      );

      const productList =
        extractProducts(result);

      console.log(
        "ALL RUDRAKSHA PRODUCT LIST:",
        productList
      );

      const formattedProducts =
        productList
          .map(formatProduct)
          .filter(Boolean);

      console.log(
        "FORMATTED RUDRAKSHA PRODUCTS:",
        formattedProducts
      );

      setProducts(
        formattedProducts
      );
    } catch (error) {
      console.error(
        "Rudraksha Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  // ==========================================
  // FETCH SUBCATEGORY PRODUCTS
  // ==========================================

  const fetchProductsBySubcategory =
    async (subcategoryId) => {
      try {
        if (
          !rudrakshaCategory?.id ||
          !subcategoryId
        ) {
          return;
        }

        setLoadingProducts(true);

        const result =
          await getProducts({
            categoryId:
              rudrakshaCategory.id,

            subcategoryId:
              subcategoryId,

            page: 1,

            limit: 12,
          });

        console.log(
          "SUBCATEGORY PRODUCTS RESPONSE:",
          result
        );

        const productList =
          extractProducts(result);

        console.log(
          "SUBCATEGORY PRODUCT LIST:",
          productList
        );

        const formattedProducts =
          productList
            .map(formatProduct)
            .filter(Boolean);

        setProducts(
          formattedProducts
        );
      } catch (error) {
        console.error(
          "Rudraksha Subcategory Products API Error:",
          error
        );

        setProducts([]);
      } finally {
        setLoadingProducts(false);
      }
    };

  // ==========================================
  // CATEGORY LOAD → ALL PRODUCTS
  // ==========================================

  useEffect(() => {
    if (rudrakshaCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(
        rudrakshaCategory.id
      );
    }
  }, [rudrakshaCategory]);

  // ==========================================
  // SUBCATEGORY CLICK
  // ==========================================

  const handleSubcategoryClick = (
    subcategory
  ) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(
      subcategory.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );
  };

  // ==========================================
  // ALL CLICK
  // ==========================================

  const handleAllClick = () => {
    if (!rudrakshaCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(
      rudrakshaCategory.id
    );
  };

  // ==========================================
  // RETURN
  // ==========================================

  return (
    <section className="rudraksha-section">
      <div className="container">

        {/* ======================================
            TOP
        ======================================= */}

        <div className="section-top">

          <h2>
            Buy 100% Natural Rudraksha
          </h2>

          <div className="tabs">

            {/* ALL RUDRAKSHA */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={
                handleAllClick
              }
              disabled={
                loadingCategories ||
                !rudrakshaCategory
              }
            >
              All Rudraksha
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (
                  <button
                    type="button"
                    key={
                      subcategory.id
                    }
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>
                )
              )}

          </div>
        </div>

        {/* ======================================
            CONTENT
        ======================================= */}

        <div className="section-content">

          {/* ====================================
              LEFT BANNER
          ===================================== */}

          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >

              {banners.map(
                (image, index) => (
                  <SwiperSlide
                    key={index}
                  >
                    <img
                      src={image}
                      alt="Original Rudraksha"
                    />
                  </SwiperSlide>
                )
              )}

            </Swiper>

          </div>

          {/* ====================================
              RIGHT PRODUCTS
          ===================================== */}

          <div className="right-products">

            {loadingCategories ||
            loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Rudraksha products..." size={56} />
              </div>
            ) : products.length === 0 ? (
              <div className="loading">
                No Rudraksha products found
              </div>
            ) : (
              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={
                  products.length > 3
                }
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >

                {products.map(
                  (product) => (
                    <SwiperSlide
                      key={product.id}
                    >
                      <ProductCard
                        product={product}
                      />
                    </SwiperSlide>
                  )
                )}

              </Swiper>
            )}

          </div>
        </div>

      </div>
    </section>
  );
}




